import { lazy, Suspense } from 'react'
import { Col, Card, Tabs, Spin } from 'antd'
import styled, { keyframes } from 'styled-components'

const Home = lazy(() => import('./home'))
const Education = lazy(() => import('./education'))
const Experience = lazy(() => import('./experience'))
const Publications = lazy(() => import('./publications'))
const Skills = lazy(() => import('./skills'))
const Portfolio = lazy(() => import('./portfolio'))
const Interests = lazy(() => import('./interests'))

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

const FadeInRightCard = styled(Card)`
  animation: 1s ${fadeInRight};
`

const TabFallback = styled.div`
  display: flex;
  justify-content: center;
  padding: 48px 0;
`

const withSuspense = (node) => (
    <Suspense
        fallback={
            <TabFallback>
                <Spin />
            </TabFallback>
        }
    >
        {node}
    </Suspense>
)

const TAB_ITEMS = [
    { key: 'home', label: 'profile', children: withSuspense(<Home />) },
    { key: 'education', label: 'education', children: withSuspense(<Education />) },
    { key: 'experience', label: 'work experience', children: withSuspense(<Experience />) },
    { key: 'publications', label: 'publications', children: withSuspense(<Publications />) },
    { key: 'skills', label: 'skills', children: withSuspense(<Skills />) },
    { key: 'portfolio', label: 'portfolio', children: withSuspense(<Portfolio />) },
    { key: 'interests', label: 'other interests', children: withSuspense(<Interests />) },
]

export default function Pages() {
    return (
        <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} xxl={{ span: 18 }}>
            <FadeInRightCard style={{ backgroundColor: '#fff' }} variant="borderless">
                <Tabs defaultActiveKey="home" items={TAB_ITEMS} />
            </FadeInRightCard>
        </Col>
    )
}
